import { makeStyles, createStyles } from "@material-ui/core/styles"

export const useChoiseOfTimeSelectStyles = makeStyles(() =>
  createStyles({
    formControl: {
      minWidth: 76,
      minHeight: 56,

      "& .MuiSelect-outlined.MuiSelect-outlined": {
        padding: "18.5px 16px",
      },
    },
  })
)
